var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex gap-1"},_vm._l((_vm.buttons),function(button,index){return _c('vs-button',{key:index,class:[
      'flex',
      'items-center',
      'justify-center',
      'rounded-full w-8 h-8 p-2',
    ],attrs:{"color":button.color,"disabled":button.disabled},nativeOn:{"click":function($event){return (() => _vm.handleClick(button, _vm.item)).apply(null, arguments)}}},[_c('vs-icon',{attrs:{"icon-pack":button.iconPack,"icon":button.icon,"size":"16px"}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }